import React from 'react';
import { css } from '@emotion/core';

export default function AsceptRatioContainer({
    backgroundImageUrl,
    aspectRatio = 1 / 1,
    maxWidth = 960,
    customStyles,
    children
}) {
    return (
        <div css={[getRootCotainerStyle(maxWidth, backgroundImageUrl), customStyles]}>
            <div css={getAsceptRatioContainerStyle(aspectRatio)}>
                <div css={childrenContainerStyle}>{children}</div>
            </div>
        </div>
    );
}

const getRootCotainerStyle = (maxWidth, backgroundImageUrl) => css`
    width: 100%;
    max-width: ${maxWidth}px;
    ${Boolean(backgroundImageUrl) &&
    `background-image: url(${backgroundImageUrl});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;`}
    &:hover .upload-bg-btn {
        display: block;
    }
`;

const getAsceptRatioContainerStyle = aspectRatio => css`
    width: 100%;
    padding-top: ${aspectRatio * 100}%; /* Aspect Ratio */
    position: relative;
`;

const childrenContainerStyle = css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
`;
